import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../store/types";
import { useNavigate } from "react-router-dom";

const DeveloperHome = () => {
    const { loggedInUser } = useSelector((state: RootState) => state.global);

    return (<>
        Developer home
    </>
    );
};

export default DeveloperHome;
